// Library Class
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { Subscription, forkJoin } from 'rxjs';
// class
import { MasterConstants } from '../../../../common/constants/master-constants';
import { FilterOption } from '../../../../common/components/filter/filter-model';
import { ControlType } from '../../../../common/components/filter/filter-enum';
// service class
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { SeedReplantService } from '../../../../services/seed/seed-replant/seed-replant.service';
import { ExcelService } from '../../../../services/infrastructure/excel.service';
import { OTIOrderLandingFilterVM } from '../../../../models/OTI/OTIOrderLandingFilterVM';
import { OtiService } from '../../../../services/oti/oti.service';
// Model class
import { SeedReplantLandingFilterVM } from '../../../../models/SeedReplant/SeedReplantLandingFilterVM';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../../common/components/confirm-dialog/confirm-dialog.component';
import { CommonService } from '../../../../services/common/common.service';

@Component({
  selector: 'app-seed-replant-landing',
  templateUrl: './seed-replant-landing.component.html',
  styleUrls: ['./seed-replant-landing.component.scss']
})
export class SeedReplantLandingComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('returnRequestTable', { read: MatSort }) returnRequestSort: MatSort;
  @ViewChild('returnRequestPaginator', { read: MatPaginator }) returnRequestPaginator: MatPaginator;
  @ViewChild('returnRequestDraftTable', { read: MatSort }) returnRequestDraftSort: MatSort;
  @ViewChild('returnRequestDraftPaginator', { read: MatPaginator }) returnRequestDraftPaginator: MatPaginator;

  returnRequestDraftColumns: string[] = [];
  returnRequestColumns: string[] = [];
  draftRequestDataSource: MatTableDataSource<any>;
  returnRequestDataSource: MatTableDataSource<any>;
  filters: OTIOrderLandingFilterVM = new OTIOrderLandingFilterVM();
  selectedTabIndex = 0;
  masterConstants = MasterConstants;
  filterOptionsData: Array<FilterOption>;
  subscription = new Subscription();
  filter: SeedReplantLandingFilterVM = new SeedReplantLandingFilterVM();
  returnRequestList: any = [];
  returnRequestDraftList: any = [];
  bannerMessage = '';
  tabNode = false;
  validateEvolveData: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  userMenuAccessList: any;
  readOnlyAccess = false;
  isApprovalAccess = false;
  isSubscriptionAccess = false;
  selectedCount = 0;
  checkBoxCount: number;
  isAllReplantProductChecked: boolean;
  disablecheckboxReplant: boolean = false; // or any appropriate default value
  enableExportExcelButton: boolean = false;
  constructor(
    private loaderService: LoaderService,
    private router: Router,
    private matDialog: MatDialog,
    private datePipe: DatePipe,
    public excelService: ExcelService,
    private seedReplantService: SeedReplantService,
    private toastrService: ToastrService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    private otiService: OtiService
  ) { }

  ngOnInit(): void {

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      const sessionData = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
      this.isSubscriptionAccess = sessionData.isSubscriptionAccess;

      this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SEED_REPLANT);
      this.isApprovalAccess = this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.SEED_REPLANT_APPROVAL);
    }

    this.seedReplantService.isApproverUser = false;
    this.fetchPageInitialApiData();
    this.setFilterAndGridColumn();
    this.setDefaultFilter();
    this.setDropDownValues();
  }

  fetchPageInitialApiData() {
    this.loaderService.setLoaderStatus(true);

    const forkJoinApIs = [];
    forkJoinApIs.push(this.seedReplantService.getLandingBannerMessage());
    forkJoinApIs.push(this.seedReplantService.getLandingGridData(this.filter));
    // forkJoinApIs.push(this.seedReplantService.getEffectiveConfigData());
    this.subscription.add(forkJoin(forkJoinApIs).subscribe((result: any[]) => {
      this.bannerMessage = result[0].message;
      this.setGridData(result[1]);
      // this.effectiveConfigData = result[2];
      // this.checkAndSetShowCreateNewRequestByConfigData();
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // Set Filter and Grid Columns
  setFilterAndGridColumn() {
    this.filterOptionsData = [
      { label: 'Account Number', key: 'accountnumber', controlType: ControlType.Text },
      { label: 'Account Name', key: 'accountname', controlType: ControlType.Text },
      { label: 'Request Date', key: 'requestdaterange', controlType: ControlType.DateRange },
      { label: 'Request Number', key: 'requestId', controlType: ControlType.Text },
      { label: 'Product Name', key: 'productname', controlType: ControlType.Text },
      { label: 'Item Number', key: 'productnumber', controlType: ControlType.Text },
      { label: 'Grower Name', key: 'growername', controlType: ControlType.Text },
      { label: 'Grower GMK', key: 'growergmk', controlType: ControlType.Text },
      { label: 'Customer PO', key: 'customerPO', controlType: ControlType.Text },
      { label: 'Status', key: 'status', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'value' },
    ];
    this.returnRequestDraftColumns = ['webOrderNumber', 'custPONumber', 'accountName', 'accountNumber', 'draftDate', 'replantProducts', 'units', 'deleteRequest'];
    this.returnRequestColumns = [ 'checkbox','webOrderNumber', 'custPONumber', 'accountName', 'accountNumber', 'requestDate', 'replantProducts', 'units', 'status', 'viewOrder'];
  }

  // Set default filter values
  setDefaultFilter() {
    this.filter = {
      accountnumber: null,
      accountname: null,
      requestdaterange: null,
      requestId: null,
      productname: null,
      productnumber: null,
      growername: null,
      growergmk: null,
      customerPO: null,
      status: null
    };
  }

  // Set Drop down values for filter
  setDropDownValues() {
    if (MasterConstants.SEED_REPLANT_STATUS_LIST) {
      this.filterOptionsData.find(x => x.key == 'status').controlData = MasterConstants.SEED_REPLANT_STATUS_LIST;
    }
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.selectedTabIndex = tabChangeEvent.index;
    this.setAccSummaryTableHeight();
  };

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }

  // set account table height
  setAccSummaryTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.TopSec').outerHeight() - $('.form-sec').outerHeight() - $('.mat-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - 250;
      $('.activeReturnRequest').css('max-height', templateHeight + 'px');
      $('.draftReturnRequest').css('max-height', templateHeight + 'px');
    }, 100);
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  createNewReplantRequest() {
    this.router.navigate(['/seed-replant-request-entry/']);
  }

  // ngOnDestroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getGridData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.seedReplantService.getLandingGridData(this.filter).subscribe((result: any[]) => {
      this.setGridData(result);
      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  setGridData(result: any) {
    // Active tab variables.
    this.returnRequestList = result.filter(x => x.status.toUpperCase() !== 'PENDING');
    this.returnRequestDataSource = new MatTableDataSource(this.returnRequestList);
    this.returnRequestDataSource.paginator = this.returnRequestPaginator;
    this.returnRequestDataSource.paginator.firstPage();
    this.returnRequestDataSource.sort = this.returnRequestSort;

    // Draft tab variables.
    this.returnRequestDraftList = result.filter(x => x.status.toUpperCase() === 'PENDING');
    this.draftRequestDataSource = new MatTableDataSource(this.returnRequestDraftList);
    this.draftRequestDataSource.paginator = this.returnRequestDraftPaginator;
    this.draftRequestDataSource.paginator.firstPage();
    this.draftRequestDataSource.sort = this.returnRequestDraftSort;
  }

  // Search Action
  filterSearchClick(event) {
    this.filter = event;
    this.getGridData();
  }

  // Clear All Action
  filterClearAllClick(event) {
    this.filter = event;
    this.getGridData();
  }

  navigateReplantRequestDetail(obj: any) {
    this.loaderService.setLoaderStatus(true);
    this.seedReplantService.setRequestHeaderId(obj.requestId);
    this.router.navigate(['/seed-replant-request-entry', obj.requestId, 0]);
    this.loaderService.setLoaderStatus(false);
  }

  emailSeedReplantDetail(obj: any) {
    let emailId = '';
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        emailId = data.resultData[0].emailId;
      }
    }

    this.tabNode = this.tabNode ? false : true;
    const emailDialog = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: { email: emailId, title: 'Send Email', tabNode: this.tabNode, dialogType: 'email' }
    });
    emailDialog.afterClosed().subscribe(emailIds => {
      // If user selected Yes
      if (emailIds) {
        const data = {
          webOrderNumber: obj.webOrderNumber,
          EmailIds: emailIds
        };
        this.loaderService.setLoaderStatus(true);
        this.seedReplantService.sendReplantNewRequestEmail(data).subscribe(result => {
          if (result) { this.loaderService.setLoaderStatus(false); }
          this.toastrService.success('Email sent');
        });
      }
      this.tabNode = false;
    });
  }

  viewSeedReplant(element) {
    this.loaderService.setLoaderStatus(true);
    if (element.jdeOrderNumber && element.jdeOrderNumber != '' && element.jdeOrderNumber != '0') {
      // this.localStorageService.set(MasterConstants.SEED_REPLANT_SALESORDERNUMBER, element.jdeOrderNumber);
      this.router.navigate(['/seed-replant-landing/']);
    } else {
      this.toastrService.error('Seed not found. Please check back.');
    }
    this.loaderService.setLoaderStatus(false);
  }

  // Delete draft request
  deletedraftrequest(seedReplantRequest: any) {
    if (seedReplantRequest) {
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '400px',
        data: { title: 'Delete Draft Request', message: 'Do you want to delete this saved request?', labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
      });
      dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.loaderService.setLoaderStatus(true);
          this.subscription.add(this.seedReplantService.deleteDraftRequest(seedReplantRequest.requestId).subscribe(result => {
            if (result) {
              this.toastrService.success('Draft order deleted successfully.');
              this.getGridData();
            }
            this.loaderService.setLoaderStatus(false);
          }, error => this.loaderService.setLoaderStatus(false)));
        }
      });
    }
  }

  public export() {
    this.loaderService.setLoaderStatus(true);

    this.subscription.add(this.seedReplantService.getLandingExportData(this.filter).subscribe((result: any[]) => {
      this.loaderService.setLoaderStatus(true);
      if (this.selectedTabIndex === 0 && this.returnRequestList && this.returnRequestList.length > 0) {
        let seedExportDataList: any = [];
        // Active tab variables.
        seedExportDataList = result.filter(x => x.requestStatus.toUpperCase() !== 'PENDING');
        var exportData = [];
        seedExportDataList.forEach(x => {
          exportData.push({
            'ReplantRequestID': x.webOrderNumber,
            'Transaction Type': x.transactionType,
            'Ship To Account': x.shipToAccount,
            'Ship To Name': x.shipToName,
            'Ship To Address': x.shipToAddress,
            'Ship To City': x.shipToCity,
            'Ship To State': x.shipToState,
            'Ship To Zip': x.shipToZipCode,
            'Grower Business Name': x.producerBusinessName,
            'Grower First Name': x.producerFirstName,
            'Grower Middle Name': x.producerMiddleName,
            'Grower Last Name': x.producerLastName,
            'Grower Address1': x.producerAddress1,
            'Grower Address2': x.producerAddress2,
            'Grower City': x.producerCity,
            'Grower State': x.producerState,
            'Grower Zip': x.producerZipCode,
            'Traite License': x.traiteLicense,
            'GrowerMasterKey': x.gmk,
            'RequestType': x.requestType,
            'AccountToCreditAccountNumber': x.creditToAccountNumber,
            'AccountToCreditAccountName': x.creditToAccountName,
            'AccountToCreditCity': x.creditToAccountCity,
            'AccountToCreditState': x.creditToAccountState,
            'AccountToCreditZip': x.creditToAccountZipCode,
            'SubmittedBy': x.createUser,
            'SubmittedDate': this.datePipe.transform(x.createTimeStamp, MasterConstants.DATE_MMDDYYYY),
            'Approved': x.approved,
            'ApprovedBy': x.userApproved,
            'ApprovedDate': x.approvedDate,
            'ProductType': x.productType == true ? 'Failed' : 'Replant',
            'CompanyNumber': x.companyNumber,
            'OriginalOrderNumber': x.orderNumber,
            'OriginalOrderType': x.orderType,
            'LineNumber': x.lineNumber,
            'ItemNumber': x.itemNumber,
            'Item': x.item,
            'SeedSize': x.seedSize,
            'LotNumber': x.lotNumber,
            'PricePerUnit': x.pricePerUnit,
            'Units': x.units,
            'UnitsFailed': x.unitsFailed,
            'Units Replant Credited': x.unitsReplantCredited,
            'InvoiceNumber': x.purchaseOrder,
            'ProductLine': x.productLine,
            'Request Date': this.datePipe.transform(x.requestDate, MasterConstants.DATE_MMDDYYYY),
            'OriginalInvoiceNumberToGrower': x.originalInvoiceNumberToGrower,
            'Plant Date': this.datePipe.transform(x.plantDate, MasterConstants.DATE_MMDDYYYY),
            'ProblemDescription': x.problemDescription,
            'Approver Notes': x.approverNotes
          });
        });
        this.excelService.exportAsExcelFile(exportData, 'ActiveReplantRequests');
      }
      else if (this.selectedTabIndex === 1 && this.returnRequestDraftList && this.returnRequestDraftList.length > 0) {
        let draftExportSeedDataList: any = [];
        // Draft tab variables.
        draftExportSeedDataList = result.filter(x => x.requestStatus.toUpperCase() === 'PENDING');
        var exportData = [];
        this.loaderService.setLoaderStatus(true);
        draftExportSeedDataList.forEach(x => {
          exportData.push({
            'ReplantRequestID': x.webOrderNumber,
            'Transaction Type': x.transactionType,
            'Ship To Account': x.shipToAccount,
            'Ship To Name': x.shipToName,
            'Ship To Address': x.shipToAddress,
            'Ship To City': x.shipToCity,
            'Ship To State': x.shipToState,
            'Ship To Zip': x.shipToZipCode,
            'Grower Business Name': x.producerBusinessName,
            'Grower First Name': x.producerFirstName,
            'Grower Middle Name': x.producerMiddleName,
            'Grower Last Name': x.producerLastName,
            'Grower Address1': x.producerAddress1,
            'Grower Address2': x.producerAddress2,
            'Grower City': x.producerCity,
            'Grower State': x.producerState,
            'Grower Zip': x.producerZipCode,
            'Traite License': x.traiteLicense,
            'GrowerMasterKey': x.gmk,
            'RequestType': x.requestType,
            'AccountToCreditAccountNumber': x.creditToAccountNumber,
            'AccountToCreditAccountName': x.creditToAccountName,
            'AccountToCreditCity': x.creditToAccountCity,
            'AccountToCreditState': x.creditToAccountState,
            'AccountToCreditZip': x.creditToAccountZipCode,
            'SubmittedBy': x.createUser,
            'SubmittedDate': this.datePipe.transform(x.createTimeStamp, MasterConstants.DATE_MMDDYYYY),
            'Approved': x.approved,
            'ApprovedBy': x.userApproved,
            'ApprovedDate': x.approvedDate,
            'ProductType': x.productType == true ? 'Failed' : 'Replant',
            'CompanyNumber': x.companyNumber,
            'OriginalOrderNumber': x.orderNumber,
            'OriginalOrderType': x.orderType,
            'LineNumber': x.lineNumber,
            'ItemNumber': x.itemNumber,
            'Item': x.item,
            'SeedSize': x.seedSize,
            'LotNumber': x.lotNumber,
            'PricePerUnit': x.pricePerUnit,
            'Units': x.units,
            'UnitsFailed': x.unitsFailed,
            'Units Replant Credited': x.unitsReplantCredited,
            'InvoiceNumber': x.purchaseOrder,
            'ProductLine': x.productLine,
            'Request Date': this.datePipe.transform(x.requestDate, MasterConstants.DATE_MMDDYYYY),
            'OriginalInvoiceNumberToGrower': x.originalInvoiceNumberToGrower,
            'Plant Date': this.datePipe.transform(x.plantDate, MasterConstants.DATE_MMDDYYYY),
            'ProblemDescription': x.problemDescription,
            'Approver Notes': x.approverNotes
          });
        });
        this.excelService.exportAsExcelFile(exportData, 'DraftsReplantRequests');
        this.loaderService.setLoaderStatus(false);
      }

      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  navigateApproveRequest(row) {
    this.seedReplantService.isViewRequest = false;
    this.seedReplantService.isApproverUser = true;
    this.seedReplantService.setRequestHeaderId(row.requestId);
    this.router.navigate(['/seed-replant-approve']);
  }

  navigateViewRequest(row) {
    if (this.isApprovalAccess && row.isDSM) {
      this.navigateApproveRequest(row);
    } else {
      this.seedReplantService.isApproverUser = false;
      this.seedReplantService.isViewRequest = true;
      this.seedReplantService.setRequestHeaderId(row.requestId);
      this.router.navigate(['/seed-replant-view-request']);
    }
  }

  viewOrderToInvoice(element) {
    this.loaderService.setLoaderStatus(true);
    if (element.jdeOrderNumber && element.jdeOrderType) {
      //this.localStorageService.set(MasterConstants.OTI_SALESORDERNUMBER, element.jdeOrderNumber);
      //this.router.navigate(['/cc/landing-data']);
      this.filters.salesOrderNumber = element.jdeOrderNumber;
      this.filters.dateInDays = 0;
      this.filters.fromOrderDate = element.draftDate !== null ? new Date(element.draftDate) : null;
      this.filters.toOrderDate = new Date();
      this.filters.orderStatus = null;
      this.filters.orderStatusText = "ALL";
      this.filters.productLineSegment = 'SEED';
      this.filters.dateRangeText = this.filters.fromOrderDate != null && this.filters.toOrderDate != null ? this.datePipe.transform(this.filters.fromOrderDate, 'MM/dd/yyyy')
        + ' - ' + this.datePipe.transform(this.filters.toOrderDate, 'MM/dd/yyyy') : "";
      this.otiService.setFilters(this.filters);
      this.router.navigate(['/order/dashboard']);
    } else {
      this.toastrService.error('Order not found. Please check back.');
    }
    this.loaderService.setLoaderStatus(false);
  }

  emailOrderDetail(obj: any) {
    let emailId = '';
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        emailId = data.resultData[0].emailId;
      }
    }

    this.tabNode = this.tabNode ? false : true;
    const dialogData = this.isSubscriptionAccess ? { title: 'Send Email', tabNode: this.tabNode, dialogType: 'nonSubscriberEmail' } : { email: emailId, title: 'Send Email', tabNode: this.tabNode, dialogType: 'email' };
    const emailDialog = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: dialogData
    });
    emailDialog.afterClosed().subscribe(emailIds => {
      // If user selected Yes
      if (emailIds) {
        const data = {
          RequestHeaderId: obj.requestId,
          EmailIds: emailIds
        };
        this.loaderService.setLoaderStatus(true);
        this.seedReplantService.sendSeedReplantNewRequestEmail(data).subscribe(result => {
          if (result) { this.loaderService.setLoaderStatus(false); }
          this.toastrService.success('Email sent');
        });
      }
      this.tabNode = false;
    });
  }

  // Generate PDF
  generatedPdf(order: any) {
    if (order.requestId) {
      this.seedReplantService.generatePdf(order.requestId);
    }
  }
  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      //this.selectedCount = this.selectedCount + 1
      this.checkBoxCount = this.returnRequestDataSource.filteredData.filter(x => x.isSelected == true).length;
      const checked = this.returnRequestDataSource.filteredData.filter(x => x.isSelected == false);
      this.selectedCount = this.checkBoxCount;
      if (this.checkBoxCount == this.returnRequestDataSource.data.length) {
        this.isAllReplantProductChecked = true;
      }
      else {
        this.isAllReplantProductChecked = false;
      }

    }
    else {
      this.checkBoxCount = this.checkBoxCount - 1;
      this.isAllReplantProductChecked = false;
      this.selectedCount = this.selectedCount - 1;
    }
    this.enableExportExcelButton = false;
    if (this.returnRequestDataSource.filteredData.filter(x => x.isSelected == true).length > 0) {
      this.enableExportExcelButton = true;
    }
  }
  enableAllCheckBoxes(isChecked) {
    this.isAllReplantProductChecked = isChecked;
    if (isChecked) {
      this.returnRequestDataSource.filteredData.forEach(x => {
        x.isSelected = true;
      });

      this.checkBoxCount = this.returnRequestDataSource?.filteredData?.filter(x => x.isSelected == true).length;
      const selectedItem = this.returnRequestDataSource?.filteredData?.filter(x => x.isSelected == true);
      this.selectedCount = this.checkBoxCount;
    }
    else {
      this.returnRequestDataSource?.filteredData?.forEach(x => {
        x.isSelected = false;
      });
      this.checkBoxCount = 0;
    }
    this.enableExportExcelButton = false;
    if (this.returnRequestDataSource.filteredData.filter(x => x.isSelected == true).length > 0) {
      this.enableExportExcelButton = true;
    }
  }

  exportToExcel() {
    var data = this.returnRequestDataSource.filteredData.filter(x => x.isSelected == true);
    if (data.length > 0) {
      var requestIds = data.map(x => x.requestId);
      this.loaderService.setLoaderStatus(true); // Show loader immediately
      this.subscription.add(this.seedReplantService
        .exportToExcel(requestIds)
        .subscribe(
          (result) => {
            if (result) {

              this.seedReplantService.base64toFile(result.base64, result.mimeType, result.fileName);
              this.loaderService.setLoaderStatus(false);
            }
            else {
              this.loaderService.setLoaderStatus(false);
              this.toastrService.error("An error occurred during export.");
            }
          },
          (error) => this.toastrService.error("An error occurred during export.")
        ));
    }
    else {
      this.toastrService.error("Select records to export.");
    }
  }
  // checkAndSetShowCreateNewRequestByConfigData() {
  //  let currentDate = new Date();
  //  this.isShowCreateNewRequestByConfigData = true;

  //  for (let productConfigData of this.effectiveConfigData) {
  //    if (new Date(productConfigData.retailerEntryEffectiveFromDate) > currentDate || new Date(productConfigData.retailerEntryEffectiveToDate) < currentDate) {
  //      this.isShowCreateNewRequestByConfigData = false;
  //      break;
  //    }
  //  }
  // }
}
